import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "person-delete",
  "use": "person-delete-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"person-delete\"><path d=\"M18.7 17.35a6 6 0 10-5.4 0A11 11 0 005 28h2a9 9 0 019-9 8.91 8.91 0 012.08.25l1.6-1.6c-.32-.11-.68-.22-.98-.3zM16 16a4 4 0 114-4 4 4 0 01-4 4zM28 20.45l-1.41-1.41-3.07 3.07-3.07-3.07-1.41 1.41 3.07 3.07-3.07 3.07L20.45 28l3.07-3.07L26.59 28 28 26.59l-3.07-3.07L28 20.45z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/person-delete.svg
// module id = pwB9
// module chunks = 39 44